import { useMutation } from '@apollo/client'
import { EDIT_TEST_LOCATIONS, } from './operations'
import { EditTestLocationsVariables, EditTestLocations } from '../../types'

export const useEditTestLocation = () =>
    useMutation<EditTestLocations, EditTestLocationsVariables>(EDIT_TEST_LOCATIONS)

